/* Account page, signature editor, approval delegation, attachments,
 * notifications and standalone pages (accept-invite, module placeholder).
 * Shared vocabulary lives in common.js / shell.js — do not duplicate it here. */
const misc = {
  // --- Account: profile ------------------------------------------------------
  'Manage your profile and the signature stamped on documents you submit and approve.':
    'Kelola profil Anda dan tanda tangan yang dibubuhkan pada dokumen yang Anda ajukan dan setujui.',
  'Profile': 'Profil',
  'First name': 'Nama depan',
  'Last name': 'Nama belakang',
  'Job title': 'Jabatan',
  'e.g. F&B Manager': 'mis. Manajer F&B',
  'Timezone': 'Zona waktu',
  'Signed in as': 'Masuk sebagai',
  'Save profile': 'Simpan profil',
  'First and last name are required.': 'Nama depan dan nama belakang wajib diisi.',
  'Profile updated': 'Profil diperbarui',
  'Could not update profile': 'Tidak dapat memperbarui profil',

  // --- Account: sign-in & security --------------------------------------------
  'Sign-in & security': 'Masuk & keamanan',
  'Change the email and password you sign in with.':
    'Ubah email dan kata sandi yang Anda gunakan untuk masuk.',
  'Sign-in email': 'Email masuk',
  'Current password (to confirm)': 'Kata sandi saat ini (untuk konfirmasi)',
  'Update email': 'Perbarui email',
  'Enter the new email address.': 'Masukkan alamat email baru.',
  'Enter your current password to confirm.': 'Masukkan kata sandi Anda saat ini untuk konfirmasi.',
  'Sign-in email updated': 'Email masuk diperbarui',
  'Use the new email the next time you sign in.': 'Gunakan email baru saat Anda masuk berikutnya.',
  'Could not update email': 'Tidak dapat memperbarui email',
  'Current password': 'Kata sandi saat ini',
  'New password': 'Kata sandi baru',
  'Confirm new password': 'Konfirmasi kata sandi baru',
  'At least 8 characters.': 'Minimal 8 karakter.',
  'Change password': 'Ubah kata sandi',
  'Enter your current password.': 'Masukkan kata sandi Anda saat ini.',
  'The new password must be at least 8 characters.': 'Kata sandi baru minimal 8 karakter.',
  'The new passwords do not match.': 'Kata sandi baru tidak cocok.',
  'Password changed': 'Kata sandi diubah',
  'Any other signed-in devices have been signed out.':
    'Perangkat lain yang sedang masuk telah dikeluarkan.',
  'Could not change password': 'Tidak dapat mengubah kata sandi',

  // --- Account: signature ----------------------------------------------------
  'Signature': 'Tanda tangan',
  'Applied automatically when you submit or approve documents.':
    'Dibubuhkan otomatis saat Anda mengajukan atau menyetujui dokumen.',
  'Current signature': 'Tanda tangan saat ini',
  'Updated {date}': 'Diperbarui {date}',
  'Create one below — draw it, type it, or upload an image.':
    'Buat di bawah — gambar, ketik, atau unggah gambar.',
  'Signature removed': 'Tanda tangan dihapus',
  'Signature method': 'Metode tanda tangan',
  'Signature style': 'Gaya tanda tangan',
  'Draw': 'Gambar',
  'Type it': 'Ketik',
  'Formal': 'Formal',
  'Type your name': 'Ketik nama Anda',
  'Sign here with your mouse or finger': 'Tanda tangani di sini dengan mouse atau jari Anda',
  'Type your name above': 'Ketik nama Anda di atas',
  'Upload a PNG or JPEG of your signature': 'Unggah PNG atau JPEG tanda tangan Anda',
  'Choose image': 'Pilih gambar',
  'Remove saved': 'Hapus yang tersimpan',
  'Save signature': 'Simpan tanda tangan',

  // --- Account: notification preferences -------------------------------------
  'Notifications': 'Notifikasi',
  'Control the approval emails you receive.': 'Atur email persetujuan yang Anda terima.',
  'Control the emails you receive.': 'Atur email yang Anda terima.',
  'Comment emails': 'Email komentar',
  'Comment emails enabled': 'Email komentar diaktifkan',
  'Comment emails turned off': 'Email komentar dimatikan',
  "When on, you'll be emailed when someone comments on a document you raised or mentions you with @. Bell notifications in the app always stay on.":
    'Saat aktif, Anda akan menerima email saat seseorang mengomentari dokumen yang Anda buat atau menyebut Anda dengan @. Notifikasi lonceng di aplikasi selalu aktif.',
  'Approval emails': 'Email persetujuan',
  'Approval emails enabled': 'Email persetujuan diaktifkan',
  'Approval emails turned off': 'Email persetujuan dimatikan',
  'Could not update notification preferences': 'Tidak dapat memperbarui preferensi notifikasi',
  "When on, you'll be emailed when a document needs your approval, when reminders or escalations fire, and when a document you raised is approved or rejected.":
    'Saat aktif, Anda akan menerima email saat sebuah dokumen membutuhkan persetujuan Anda, saat pengingat atau eskalasi terkirim, dan saat dokumen yang Anda buat disetujui atau ditolak.',

  // --- Account: passkeys -------------------------------------------------------
  'Passkeys': 'Kunci sandi (passkey)',
  'Sign in with Touch ID, Face ID, Windows Hello, or a security key — no password needed.':
    'Masuk dengan Touch ID, Face ID, Windows Hello, atau kunci keamanan — tanpa kata sandi.',
  'No passkeys yet': 'Belum ada passkey',
  'Add a passkey to sign in with your fingerprint, face, or device PIN.':
    'Tambahkan passkey untuk masuk dengan sidik jari, wajah, atau PIN perangkat Anda.',
  'This browser does not support passkeys.': 'Browser ini tidak mendukung passkey.',
  'Added {date}': 'Ditambahkan {date}',
  'Last used {date}': 'Terakhir digunakan {date}',
  'Never used': 'Belum pernah digunakan',
  'Add passkey': 'Tambah passkey',
  'Passkey added': 'Passkey ditambahkan',
  'You can now sign in with your fingerprint, face, or device PIN.':
    'Sekarang Anda dapat masuk dengan sidik jari, wajah, atau PIN perangkat.',
  'Could not add passkey': 'Tidak dapat menambahkan passkey',
  'Passkey removed': 'Passkey dihapus',
  'Could not remove passkey': 'Tidak dapat menghapus passkey',
  'Remove passkey?': 'Hapus passkey?',
  '"{name}" will no longer work for signing in.':
    '"{name}" tidak akan bisa digunakan untuk masuk lagi.',

  // --- Account: devices & sessions ----------------------------------------------
  'Devices & sessions': 'Perangkat & sesi',
  "Everywhere you're signed in right now. Sign out anything you don't recognize.":
    'Semua tempat Anda sedang masuk saat ini. Keluarkan apa pun yang tidak Anda kenali.',
  'No active sessions': 'Tidak ada sesi aktif',
  'Unknown device': 'Perangkat tidak dikenal',
  'This device': 'Perangkat ini',
  'Signed in {date}': 'Masuk {date}',
  'Last active {date}': 'Terakhir aktif {date}',
  'Device signed out': 'Perangkat dikeluarkan',
  'Could not sign the device out': 'Tidak dapat mengeluarkan perangkat',
  '{count} other device(s) signed out': '{count} perangkat lain dikeluarkan',
  'Could not sign other devices out': 'Tidak dapat mengeluarkan perangkat lain',
  'Sign out all other devices': 'Keluarkan semua perangkat lain',
  'Sign this device out?': 'Keluarkan perangkat ini?',
  'It will need to sign in again to use the system.':
    'Perangkat itu harus masuk lagi untuk menggunakan sistem.',
  'Sign out all other devices?': 'Keluarkan semua perangkat lain?',
  'Every session except this one will be ended immediately.':
    'Semua sesi kecuali sesi ini akan diakhiri segera.',
  'Sign out others': 'Keluarkan yang lain',

  // --- Account: out-of-office delegation --------------------------------------
  'Out-of-office cover': 'Penggantian saat tidak di kantor',
  "Delegate your approvals to a colleague while you're away.":
    'Delegasikan persetujuan Anda kepada rekan kerja selama Anda pergi.',
  'Delegate to': 'Delegasikan kepada',
  'Delegate approvals to': 'Delegasikan persetujuan kepada',
  'Choose a colleague…': 'Pilih rekan kerja…',
  'Search colleagues…': 'Cari rekan kerja…',
  'No colleagues found': 'Rekan kerja tidak ditemukan',
  'Until': 'Hingga',
  'Reason (optional)': 'Alasan (opsional)',
  'e.g. Annual leave': 'mis. Cuti tahunan',
  'Schedule cover': 'Jadwalkan penggantian',
  'No active cover': 'Tidak ada penggantian aktif',
  "Schedule a colleague to approve in your place while you're out.":
    'Jadwalkan rekan kerja untuk menyetujui atas nama Anda selama Anda tidak ada.',
  'You delegated': 'Anda mendelegasikan',
  'Covering for': 'Menggantikan',
  'to {name}': 'kepada {name}',
  'from {name}': 'dari {name}',
  'colleague': 'rekan kerja',
  'Scheduled': 'Terjadwal',
  'Cancel delegation': 'Batalkan delegasi',
  'Choose a colleague to cover for you.': 'Pilih rekan kerja untuk menggantikan Anda.',
  'Pick a start and end date.': 'Pilih tanggal mulai dan tanggal selesai.',
  'The end date must be on or after the start date.':
    'Tanggal selesai harus sama dengan atau setelah tanggal mulai.',
  'Delegation scheduled': 'Delegasi dijadwalkan',
  'Delegation cancelled': 'Delegasi dibatalkan',
  'Could not load delegations': 'Tidak dapat memuat delegasi',
  'Could not create delegation': 'Tidak dapat membuat delegasi',
  'Could not cancel delegation': 'Tidak dapat membatalkan delegasi',

  // --- Attachments -------------------------------------------------------------
  'No attachments': 'Tidak ada lampiran',
  'Attach quotes, specs, photos or invoices for this document.':
    'Lampirkan penawaran, spesifikasi, foto, atau faktur untuk dokumen ini.',
  'No files have been attached.': 'Belum ada berkas yang dilampirkan.',
  'Uploaded {date}': 'Diunggah {date}',
  'Open attachment': 'Buka lampiran',
  'Delete attachment': 'Hapus lampiran',
  'Upload attachment': 'Unggah lampiran',
  'Attachment type': 'Tipe lampiran',
  'Description (optional)': 'Deskripsi (opsional)',
  'PDF, image or Office file up to {n} MB': 'PDF, gambar, atau berkas Office hingga {n} MB',
  'Delete "{name}"? This permanently removes the file.':
    'Hapus "{name}"? Ini menghapus berkas secara permanen.',
  'Choose a file to upload': 'Pilih berkas untuk diunggah',
  'Attachment uploaded': 'Lampiran diunggah',
  'Upload failed': 'Unggahan gagal',
  'Attachment removed': 'Lampiran dihapus',
  'Could not load attachments': 'Tidak dapat memuat lampiran',
  'Could not open attachment': 'Tidak dapat membuka lampiran',
  'Could not remove attachment': 'Tidak dapat menghapus lampiran',
  'Quote': 'Penawaran',
  'Spec': 'Spesifikasi',
  'Photo': 'Foto',
  'Other': 'Lainnya',

  // --- Notification bell --------------------------------------------------------
  'Notifications, {count} unread': 'Notifikasi, {count} belum dibaca',
  'Mark all read': 'Tandai semua telah dibaca',
  'You’re all caught up': 'Semua notifikasi sudah dibaca',
  'just now': 'baru saja',
  '{n}m ago': '{n} mnt lalu',
  '{n}h ago': '{n} jam lalu',
  '{n}d ago': '{n} hari lalu',

  // --- Accept-invite page ---------------------------------------------------------
  "You've been invited.": 'Anda telah diundang.',
  "Set your password to join your team's procurement workspace.":
    'Atur kata sandi Anda untuk bergabung dengan ruang kerja pengadaan tim Anda.',
  "You're all set": 'Semua siap',
  'Your account is ready. Redirecting you to sign in…':
    'Akun Anda sudah siap. Mengalihkan Anda ke halaman masuk…',
  'Join {name}': 'Bergabung dengan {name}',
  'Accepting invitation for': 'Menerima undangan untuk',
  'At least 8 characters': 'Minimal 8 karakter',
  'Confirm password': 'Konfirmasi kata sandi',
  'Create account': 'Buat akun',
  'Invitation unavailable': 'Undangan tidak tersedia',
  'Go to sign in': 'Ke halaman masuk',
  'Please enter your name.': 'Silakan masukkan nama Anda.',
  'Password must be at least 8 characters.': 'Kata sandi minimal 8 karakter.',
  'Passwords do not match.': 'Kata sandi tidak cocok.',
  'Could not accept the invitation.': 'Tidak dapat menerima undangan.',
  'This invitation link is invalid.': 'Tautan undangan ini tidak valid.',
  'This invitation link is invalid or has expired.':
    'Tautan undangan ini tidak valid atau sudah kedaluwarsa.',

  // --- Module placeholder page ------------------------------------------------------
  'Coming soon': 'Segera hadir',
  '{title} is part of the procurement roadmap and will be available in an upcoming phase.':
    '{title} adalah bagian dari peta jalan pengadaan dan akan tersedia pada fase mendatang.',
};

export default misc;
